import React, { useEffect, useState } from "react"
import { userRequest } from "../../requestMethods"
import { ArrowDownward, ArrowUpward } from "@material-ui/icons"
// Styles
import { Container, Item, Money, MoneyWrapper, Rate, Sub, Title } from "./FeaturedInfo.styles"

const FeaturedInfo = () => {
    const [income, setIncome] = useState([])
    const [incomeChange, setIncomeChange] = useState(0)

    useEffect(() => {
        const getIncome = async () => {
            try {
                const res = await userRequest.get("orders/income")
                setIncome(res.data)
                setIncomeChange((res.data[0].total - res.data[1].total) * 100 / res.data[1].total)
            } catch (err) {
                setIncome(["Error fetching income", err])
            }
        }
        getIncome()
    }, [])

    return (
        <Container>
            <Item>
                <Title>Revenue</Title>
                <MoneyWrapper>
                    <Money>6000€</Money>
                    <Rate>
                        -18.8%
                        <ArrowDownward color="secondary" />
                    </Rate>
                </MoneyWrapper>
                <Sub>Compared to last month</Sub>
            </Item>
            <Item>
                <Title>Sales</Title>
                <MoneyWrapper>
                    <Money>{parseInt(income[0]?.total)}€</Money>
                    <Rate>
                        {incomeChange < 0 ? "" : "+"}
                        {incomeChange.toFixed(1)}%
                        {incomeChange < 0 ? <ArrowDownward color="secondary" /> : <ArrowUpward color="primary" />}
                    </Rate>
                </MoneyWrapper>
                <Sub>Compared to last month</Sub>
            </Item>
            <Item>
                <Title>Cost</Title>
                <MoneyWrapper>
                    <Money>2200€</Money>
                    <Rate>
                        +5.5%
                        <ArrowUpward color="primary" />
                    </Rate>
                </MoneyWrapper>
                <Sub>Compared to last month</Sub>
            </Item>
        </Container>
    )
}

export default FeaturedInfo
